import { Injectable } from "@angular/core";
import { BehaviorSubject, lastValueFrom } from "rxjs";
import { ItemModel, ItemService } from "../swagger";
import { UserDataService } from "../user/user.service";

@Injectable({
  providedIn: "root",
})
export class OrderItemsCacheService {
  // Items for the location of the currently selected customer.
  items = new BehaviorSubject<ItemModel[]>([]);
  // False while a fetch is in flight so the UI can show a loading state instead
  // of "No result found".
  itemsLoaded = new BehaviorSubject<boolean>(false);
  private currentUser: any;

  constructor(
    private itemService: ItemService,
    private userService: UserDataService,
  ) {
    this.userService.user$.subscribe((user) => {
      if (user?.userId != this.currentUser?.userId) {
        this.clearSelection();
        this.currentUser = user;
      }
    });
  }

  // Always hits /item/all so the item list (and its inventory counts) is fresh
  // on every customer change. A customer with no location falls back to the
  // unscoped call the backend resolves to its own default.
  async load(locationId?: number): Promise<void> {
    this.itemsLoaded.next(false);
    try {
      const result = (await lastValueFrom(
        this.itemService.apiItemAllGet(locationId ? { locationId } : {}),
      )) as any;
      this.items.next(result.data ? result.data : []);
    } catch (e) {
      this.items.next([]);
      throw e;
    } finally {
      this.itemsLoaded.next(true);
    }
  }

  // Stop emitting items when no customer is selected.
  clearSelection(): void {
    this.items.next([]);
    this.itemsLoaded.next(false);
  }
}
